import { render } from "./SuggestDropdown.vue?vue&type=template&id=e6a8faa8&scoped=true"
import script from "./SuggestDropdown.vue?vue&type=script&lang=js"
export * from "./SuggestDropdown.vue?vue&type=script&lang=js"

import "./SuggestDropdown.vue?vue&type=style&index=0&id=e6a8faa8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a8faa8"]])

export default __exports__